import { PitcherSingleSessionReportChartConfigDto, TableChartConfigDto } from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import TableChartSidebar from 'components/Table/TableChartSidebar';

const PitcherSingleSessionGameStatsChartSidebar = (
  props: ChartConfigProps<TableChartConfigDto, PitcherSingleSessionReportChartConfigDto>
) => {
  return <TableChartSidebar chartId='PitcherSingleSessionGameStatsChart' chartKey='pitcherSingleSessionGameStatsChartConfig' {...props} />;
};

export default PitcherSingleSessionGameStatsChartSidebar;
